export default "__VITE_ASSET__Dq8AoW8D__"